import React from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';
import {Switch, Route} from 'react-router-dom';
import {ConnectedRouter} from 'connected-react-router';
import MyNavbar from '../components/navbar';
import App from './app';
import Login from './login';
import SignUpPartner from './sign-up-partner';
import SignUpPlayer from './sign-up-player';
import PlayerProfile from './player-profile';
import PlayerVideo from './player-video';
import PlayerVideoAnalysisPage from '../components/player-video-analysis-page';
import PartnerProfile from './partner-profile';
import PartnerEvents from './partner-events';
import PartnerEvent from './partner-event';
import PartnerFields from './partner-fields';
import PartnerField from './partner-field';
import PartnerService from './partner-service';
import PartnerFieldCalendar from './partner-field-calendar';
import PartnerServiceCalendar from './partner-service-calendar';
import ShowPartner from './show-partner';
import ShowPartnerSpecialist from './show-partner-specialist';
import RoleHome from './role-home';
import PlayerBookingCalendar from './player-booking-calendar';
import PlayerServiceBookingCalendar from './player-service-booking-calendar';
import PartnerBookingCalendar from './partner-booking-calendar';
import PartnerServiceBookingCalendar from './partner-service-booking-calendar';
import VerifyEmail from '../components/verify-email';
import ResetPassword from '../components/reset-password';
import ConfirmPlayerAffiliation from '../components/confirm-player-affiliation';
import ConfirmChangeEmail from '../components/confirm-change-email';
import AdminAdditionalSpace from '../components/admin-additional-space.js';
import UserTopUpAccount from '../components/user-top-up-account';
import PlayerShowPartners from '../components/player-show-partners';
import AdminPlayerManagement from '../components/admin-player-management';
import AdminSlotManagement from '../components/admin-slot-management';
import VideoSharing from '../components/video-sharing';
import AdminCreatePartner from '../components/admin-create-partner';
import withTracker from '../components/with-tracker';
import PlayerReplayerTv from '../components/player-replayer-tv';
import PlayerReplayerTvVideoPartner from '../components/player-replayer-tv-video-partner';
import PlayerVideoStore from '../components/player-video-store';
import PlayerVideoStorePartner from '../components/player-video-store-partner';
import AdminPartnerManagement from '../components/admin-partner-management';
import AdminShowPartner from '../components/admin-show-partner';
import PlayerReplayerTvHome from '../components/player-replayer-tv-home';
import AdminSponsor from '../components/admin-sponsor';
import PlayerSponsor from '../components/player-sponsor';
import PlayerCalendars from '../components/player-calendars';
import AdminReport from '../components/admin-report';
import AdminNvrTracking from '../components/admin_nvr_tracking';
import adminConcatSliceVideosReport from '../components/admin-concat-slice-videos-report.js';
import adminDeleteVideoReport from '../components/admin-delete-video-report.js';
import AdminRtvCategories from '../components/admin-rtv-categories'
import AdminNvrDashboard from '../components/admin_nvr_dashboard';
import AdminNvrConfiguration from '../components/admin-nvr-configuration';
import PartnerReport from '../components/partner-report';
import PlayerShowSportSpecialists from '../components/player-show-sport-specialists';
import PartnerVideoStore from '../components/partner-video-store';
import PartnerReplayerTvHome from '../components/partner-replayer-tv-home';
import PartnerReplayerTv from '../components/partner-replayer-tv';
import PartnerVideo from './partner-video';
import PlayerBookings from '../components/player-bookings';
import PlayerOpenMatches from '../components/player-open-matches';
import PartnerOpenMatches from '../components/partner-open-matches';
import OpenMatchCreateWizard from '../components/open-match-create-wizard';
import OpenMatchDetailPage from '../components/open-match-detail-page';
import PlayerLiveVideos from '../components/player-live-videos';
import PlayerComingSoonVideos from '../components/player-coming-soon-videos';
import PartnerAffiliations from '../components/partner-affiliations';
import AdminSetting from '../components/admin-setting.js';
import AdminShop from '../components/admin-shop';
import PartnerShop from '../components/partner-shop';
import AdminAi from '../components/admin-ai';
import AdminRepLearning from '../components/admin-rep-learning';
import PublicShop from '../components/public-shop';
import PublicPartnerCatalog from '../components/public-partner-catalog';
import MobileLogin from '../components/mobile-login';
import BookingTopupInvitation from '../components/booking-topup-invitation';
import CommunicationsCenter from '../components/communications-center';
import RepAssistant from '../components/rep-assistant';

const Root = ({store, history}) => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <MyNavbar/>
      <Switch>
        <Route exact path="/" component={withTracker(RoleHome)}/>
        <Route exact path="/home-redesign" component={withTracker(RoleHome)}/>
        <Route exact path="/home-legacy" component={withTracker(App)}/>
        <Route path="/shop/:partnerSlug?" component={withTracker(PublicShop)}/>
        <Route path="/login" component={withTracker(Login)}/>
        <Route exact path="/mobile-login" component={MobileLogin}/>
        <Route path="/p/:partnerSlug" component={withTracker(PublicPartnerCatalog)}/>
        <Route path="/club/:partnerSlug" component={withTracker(PublicPartnerCatalog)}/>
        <Route path="/sign-up-player" component={withTracker(SignUpPlayer)}/>
        <Route path="/sign-up-partner" component={withTracker(SignUpPartner)}/>
        <Route path="/player-profile" component={withTracker(PlayerProfile)}/>
        <Route path="/analysis/:sharingId" component={withTracker(PlayerVideoAnalysisPage)}/>
        <Route path="/player-video-analysis/:requestId" component={withTracker(PlayerVideoAnalysisPage)}/>
        <Route path="/partner-video-analysis/:requestId" component={withTracker(PlayerVideoAnalysisPage)}/>
        <Route path="/player-video" component={withTracker(PlayerVideo)}/>
        <Route path="/partner-video" component={withTracker(PartnerVideo)}/>
        <Route path="/partner-profile" component={withTracker(PartnerProfile)}/>
        <Route path="/partner-events" component={withTracker(PartnerEvents)}/>
        <Route path="/partner-event" component={withTracker(PartnerEvent)}/>
        <Route path="/partner-fields" component={withTracker(PartnerFields)}/>
        <Route path="/partner-field" component={withTracker(PartnerField)}/>
        <Route path="/partner-service" component={withTracker(PartnerService)}/>
        <Route path="/partner-field-calendar" component={withTracker(PartnerFieldCalendar)}/>
        <Route path="/partner-service-calendar" component={withTracker(PartnerServiceCalendar)}/>
        <Route path="/partner-report" component={withTracker(PartnerReport)}/>
        <Route path="/partner-shop" component={withTracker(PartnerShop)}/>
        <Route path="/show-partner" component={withTracker(ShowPartner)}/>
        <Route path="/show-partner-specialist" component={withTracker(ShowPartnerSpecialist)}/>
        <Route path="/player-booking-calendar" component={withTracker(PlayerBookingCalendar)}/>
        <Route path="/player-service-booking-calendar" component={withTracker(PlayerServiceBookingCalendar)}/>
        <Route path="/player-calendars" component={withTracker(PlayerCalendars)}/>
        <Route path="/partner-booking-calendar" component={withTracker(PartnerBookingCalendar)}/>
        <Route path="/partner-video-store" component={withTracker(PartnerVideoStore)}/>
        <Route path="/partner-service-booking-calendar" component={withTracker(PartnerServiceBookingCalendar)}/>
        <Route path="/verify-email/:token" component={withTracker(VerifyEmail)}/>
        <Route path="/reset-password/:token" component={withTracker(ResetPassword)}/>
        <Route path="/confirm-player-affiliation" component={withTracker(ConfirmPlayerAffiliation)}/>
        <Route path="/confirm-change-email/:token" component={withTracker(ConfirmChangeEmail)}/>
        <Route path="/admin-report" component={withTracker(AdminReport)}/>
        <Route path="/admin-additional-space" component={withTracker(AdminAdditionalSpace)}/>
        <Route path="/user-top-up-account" component={withTracker(UserTopUpAccount)}/>
        <Route path="/booking-invitation/:token" component={withTracker(BookingTopupInvitation)}/>
        <Route path="/messages" component={withTracker(CommunicationsCenter)}/>
        <Route path="/rep-assistant" component={withTracker(RepAssistant)}/>
        <Route path="/player-show-sport-centers" component={withTracker(PlayerShowPartners)}/>
        <Route path="/player-show-sport-specialists" component={withTracker(PlayerShowSportSpecialists)}/>
        <Route path="/admin-player-management" component={withTracker(AdminPlayerManagement)}/>
        <Route path="/admin-slot-management" component={withTracker(AdminSlotManagement)}/>
        <Route path="/v/:sharedId" component={withTracker(VideoSharing)}/>
        <Route path="/admin-create-partner" component={withTracker(AdminCreatePartner)}/>
        <Route path="/player-replayer-tv" component={withTracker(PlayerReplayerTv)}/>
        <Route path="/player-replayer-tv-video-partner" component={withTracker(PlayerReplayerTvVideoPartner)}/>
        <Route path="/player-video-store" component={withTracker(PlayerVideoStore)}/>
        <Route path="/player-video-store-partner" component={withTracker(PlayerVideoStorePartner)}/>
        <Route path="/admin-partner-management" component={withTracker(AdminPartnerManagement)}/>
        <Route path="/admin-show-partner" component={withTracker(AdminShowPartner)}/>
        <Route path="/player-replayer-tv-home" component={withTracker(PlayerReplayerTvHome)}/>
        <Route path="/partner-replayer-tv-home" component={withTracker(PartnerReplayerTvHome)}/>
        <Route path="/partner-replayer-tv" component={withTracker(PartnerReplayerTv)}/>
        <Route path="/admin-sponsor" component={withTracker(AdminSponsor)}/>
        <Route path="/player-sponsor" component={withTracker(PlayerSponsor)}/>
        <Route path="/admin-rtv-categories" component={withTracker(AdminRtvCategories)}/>
        <Route path="/nvr-dashboard" component={withTracker(AdminNvrDashboard)}/>
        <Route path="/admin-nvr-configuration" component={withTracker(AdminNvrConfiguration)}/>
        <Route path="/admin-nvr-tracking" component={withTracker(AdminNvrTracking)}/>
        <Route path="/admin-concat-slice-videos-report" component={withTracker(adminConcatSliceVideosReport)}/>
        <Route path="/admin-delete-video-report" component={withTracker(adminDeleteVideoReport)}/>
        <Route path="/player-bookings" component={withTracker(PlayerBookings)}/>
        <Route path="/player-open-matches" component={withTracker(PlayerOpenMatches)}/>
        <Route path="/partner-open-matches/create" component={withTracker(OpenMatchCreateWizard)}/>
        <Route path="/partner-open-matches" component={withTracker(PartnerOpenMatches)}/>
        <Route path="/open-matches/create" component={withTracker(OpenMatchCreateWizard)}/>
        <Route path="/matches/:publicId" component={withTracker(OpenMatchDetailPage)}/>
        <Route path="/player-live-videos" component={withTracker(PlayerLiveVideos)}/>
        <Route path="/player-coming-soon-videos" component={withTracker(PlayerComingSoonVideos)}/>
        <Route path="/partner-affiliations" component={withTracker(PartnerAffiliations)}/>
        <Route path="/admin-setting" component={withTracker(AdminSetting)}/>
        <Route path="/admin-ai" component={withTracker(AdminAi)}/>
        <Route path="/admin-rep" component={withTracker(AdminRepLearning)}/>
        <Route path="/admin-shop" component={withTracker(AdminShop)}/>
      </Switch>
      <footer className="footer bg_blue_rp py-3">
        <div className="container text-center">
          <p>Copyrights &copy; {new Date().getFullYear()} by Replayer. All Rights Reserved. | Replayer S.r.l. P.IVA 02685150993 capitale sociale versato 216.066,48 &euro;</p>
        </div>
      </footer>
    </ConnectedRouter>
  </Provider>
);

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default Root;
